import { Target, MessageSquareText, Gamepad2 } from "lucide-react";
import { PILLARS } from "../../config/landingConfig";
import { Reveal } from "./Reveal";

const STYLES = {
  magenta: "bg-magenta text-white",
  cyan: "bg-cyan text-ink",
  violet: "bg-violet text-white",
};
const ICONS = [Target, MessageSquareText, Gamepad2];

export const Pillars = () => (
  <section data-testid="pillars-section" className="border-y-4 border-ink bg-white">
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:py-24">
      <Reveal>
        <h2 className="text-2xl font-extrabold uppercase tracking-tight text-ink sm:text-3xl lg:text-4xl">
          Trzy filary <span className="marker-magenta">AI Speaking Games</span>
        </h2>
      </Reveal>
      <div className="mt-10 grid gap-6 md:grid-cols-3">
        {PILLARS.map((pillar, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={pillar.n} delay={i * 0.12} className="h-full">
              <article
                data-testid={`pillar-card-${pillar.n}`}
                className={`hover-lift flex h-full flex-col rounded-3xl border-2 border-ink p-7 shadow-hard ${STYLES[pillar.color]}`}
              >
                <div className="flex items-start justify-between">
                  <span className="font-display text-5xl opacity-90">{pillar.n}</span>
                  <span className="flex h-12 w-12 items-center justify-center rounded-2xl border-2 border-ink bg-white text-ink">
                    <Icon className="h-6 w-6" aria-hidden="true" />
                  </span>
                </div>
                <h3 className="font-display mt-8 text-2xl uppercase tracking-wide">{pillar.title}</h3>
                <p className={`mt-3 text-base leading-relaxed ${pillar.color === "cyan" ? "text-ink/80" : "text-white/90"}`}>
                  {pillar.text}
                </p>
              </article>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
